import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=1b4acb70&scoped=true&"
import script from "./tab.vue?vue&type=script&lang=js&"
export * from "./tab.vue?vue&type=script&lang=js&"
import style0 from "./tab.vue?vue&type=style&index=0&id=1b4acb70&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4acb70",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("K:\\website\\tmp\\2021.7-12\\mmlzcyy_project\\screen\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b4acb70')) {
      api.createRecord('1b4acb70', component.options)
    } else {
      api.reload('1b4acb70', component.options)
    }
    module.hot.accept("./tab.vue?vue&type=template&id=1b4acb70&scoped=true&", function () {
      api.rerender('1b4acb70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/page/mapDrawer/enterpriseDrawer/tab.vue"
export default component.exports